
import { AlternativeFormatsIframeTemplate } from './templates/AlternativeFormatsIframeTemplate';
import { InstructorFeedbackIframeTemplate } from './templates/InstructorFeedbackIframeTemplate';
import { ScoreIndicatorTemplate } from './templates/ScoreIndicatorTemplate';
import { SeizureGuardTemplate } from './templates/SeizureGuardTemplate';

export const alternativeFormatsIframe = new AlternativeFormatsIframeTemplate();
export const instructorFeedbackIframe = new InstructorFeedbackIframeTemplate();
export const scoreIndicator = new ScoreIndicatorTemplate();
export const seizureGuard = new SeizureGuardTemplate();
